import { ADD_RECENTLY_CREATED } from './types';

export const addRecentlyCreated = (feature) => {
  return {
    type: ADD_RECENTLY_CREATED,
    payload: feature,
  };
};
